const RELOAD_KEY = "pw-asset-reload";

function reloadOnceForStaleAsset(): void {
    try {
        if (sessionStorage.getItem(RELOAD_KEY)) return;
        sessionStorage.setItem(RELOAD_KEY, "1");
    } catch {
        return;
    }
    window.location.reload();
}

/**
 * After a deploy, an open tab still requests the previous hashed chunk.
 * Vite emits `vite:preloadError` for that lazy import (WEBAPP-94, WEBAPP-DB).
 */
export function isStaleAssetMessage(message: string): boolean {
    return (
        /not a valid JavaScript MIME type/i.test(message) ||
        /Failed to fetch dynamically imported module/i.test(message) ||
        /error loading dynamically imported module/i.test(message) ||
        /Importing a module script failed/i.test(message) ||
        /evaluating ['"]e\[t\?\?/i.test(message)
    );
}

export function installStaleChunkReload(): void {
    window.addEventListener("vite:preloadError", (event) => {
        event.preventDefault();
        reloadOnceForStaleAsset();
    });
    window.addEventListener("error", (event) => {
        const message = event.message || "";
        if (!isStaleAssetMessage(message)) return;
        event.preventDefault();
        reloadOnceForStaleAsset();
    });
    window.addEventListener("unhandledrejection", (event) => {
        const reason = event.reason;
        const message = reason instanceof Error ? reason.message : String(reason ?? "");
        if (!isStaleAssetMessage(message)) return;
        event.preventDefault();
        reloadOnceForStaleAsset();
    });
    // Allow a later deploy in this tab to reload once, after this load has settled.
    window.setTimeout(() => {
        try {
            sessionStorage.removeItem(RELOAD_KEY);
        } catch {
            // sessionStorage can throw in private mode.
        }
    }, 15_000);
}
